import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Component from "./Components";
import Pages from "./pages";
import strings from "./utils/strings";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";

function Navigation() {
  return (
    <Routes>
      <Route element={<PublicRoute element={Component.CommonLayout} />}>
        <Route exact path={strings.navigation.welcome} element={<Pages.WelcomeScreen />} />
      </Route>
      <Route element={<PrivateRoute element={Component.SessionValidation} />}>
        <Route element={<Component.LayoutComponent />}>
          <Route exact path={strings.navigation.department} element={<Pages.Department />} />
          <Route exact path={strings.navigation.departmentPrice} element={<Pages.DepartmentPrice />} />
          <Route exact path={strings.navigation.patientProfile} element={<Pages.PatientProfile />} />
          <Route exact path={strings.navigation.manageDriver} element={<Pages.DriverProfile />} />
          <Route exact path={strings.navigation.manageAmbulance} element={<Pages.Ambulance />} />
          <Route exact path={strings.navigation.manageNurseReq} element={<Pages.NurseRequest />} />
          <Route exact path={strings.navigation.viewNurseReqDetails} element={<Pages.ServiceDetails />} />
          <Route exact path={strings.navigation.viewApprovedRequestDetails} element={<Pages.ApprovedRequestDetailsPage />} />
          <Route exact path={strings.navigation.viewSessionDetails} element={<Pages.SessionDetailsPage />} />
          <Route exact path={strings.navigation.reallocationLog} element={<Pages.ReallocationLogPage />} />

          {/* NURSING CARE */}
          <Route exact path={strings.navigation.editNurse} element={<Component.EditNurse />} />
          <Route exact path={strings.navigation.createNurse} element={<Component.CreateNurse />} />
          <Route exact path={strings.navigation.nurseList} element={<Component.NurseList />} />
          <Route exact path={strings.navigation.additionalConsumableList} element={<Component.AdditionalConsumableList />} />
          <Route exact path={strings.navigation.addConsumable} element={<Component.CreateConsumableList />} />
          <Route exact path={strings.navigation.editConsumable} element={<Component.EditConsumable />} />
          <Route exact path={strings.navigation.healthArticle} element={<Pages.Article />} />
          <Route exact path={strings.navigation.nationalID} element={<Pages.NationalID />} />
          <Route exact path={strings.navigation.termsCondition} element={<Pages.TermsCondition />}>
            <Route index element={<Component.ListTermsCondition />} />
            <Route path="update" element={<Component.EditTermsCondition />} />
            <Route path="view" element={<Component.ViewTermsCondition />} />
          </Route>

          <Route path={strings.navigation.nursingCareManageService} element={<Component.ManageServicesList />} />
          <Route path={strings.navigation.manageServiceGroup} element={<Component.ManageServicesList />} />
          <Route path={strings.navigation.manageSubServiceGroup} element={<Component.ManageServicesList />} />
          <Route path={strings.navigation.manageServiceItem} element={<Component.ManageServicesList />} />
          <Route path={strings.navigation.createService} element={<Component.CreateServiceMain />} />
          <Route path={strings.navigation.serviceDetail} element={<Component.ManageRequestServiceDetails />} />
          <Route path={strings.navigation.manageTranspotationFees} element={<Component.TransportationList />} />
          <Route path={strings.navigation.createZoneFees} element={<Component.AddNewZoneFee />} />
          <Route path={strings.navigation.editZoneFees} element={<Component.EditZoneFee />} />
          <Route path={strings.navigation.patientHistory} element={<Component.SearchPatientHistory />} />
          <Route path={strings.navigation.patientHistoryDetails} element={<Component.PatientHistoryDetails />} />
          <Route path={strings.navigation.additionalBilling} element={<Component.AdditionalBillingList />} />
          <Route path={strings.navigation.additionalCostManagement} element={<Component.AdditionalBillingList />} />
          <Route path={strings.navigation.paymentDetails} element={<Component.PaymentDetails />} />
          <Route path={strings.navigation.specimenLogistics} element={<Component.SpecimenLogisticsList />} />
          <Route exact path={strings.navigation.viewRequestDetails} element={<Component.ViewRequestDetails />} />
          <Route exact path={strings.navigation.alpha2codeList} element={<Component.Alpha2CodeList />} />
        </Route>
      </Route>
      <Route path="*" element={<Pages.PageNotFound />} />
    </Routes>
  );
}

export default Navigation;
